import { render, staticRenderFns } from "./EditPeriodModal.vue?vue&type=template&id=99923582&scoped=true&lang=pug"
import script from "./EditPeriodModal.vue?vue&type=script&lang=js"
export * from "./EditPeriodModal.vue?vue&type=script&lang=js"
import style0 from "./EditPeriodModal.vue?vue&type=style&index=0&id=99923582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99923582",
  null
  
)

export default component.exports